module.exports={
    //Cim:"http://localhost:3000"
    Cim:"https://nodejs205.dszcbaross.edu.hu"
}


